import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import PolicyViewer from 'components/policy/PolicyViewer';
import PageTemplate from 'components/base/PageTemplate';

const Policy = ({ match }) => {
  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PolicyViewer mode={match.params.mode || 'privacy'} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Policy;



// WEBPACK FOOTER //
// ./src/pages/Policy.js